import React, { useEffect, useState }  from "react";
import { connect } from "react-redux";
import SummaryCard from "./components/SummaryCard";
import { Award, Heart, MessageCircleHeart, TrendingUp, GraduationCap} from "lucide-react";
import FilterToolBar from "./components/FilterToolBar";
import { recognitionFilters } from "variables/constants";
import RecognitionCard from "./components/RecognitionCard";
import ShoutoutCard from "./components/ShoutoutCard";
import {
  getRecognitionWallList
} from "../../../../redux/recognitionwall/recognitionWallState";
import {
  getRecognitionStats
} from "../../../../redux/overview/overviewState";
import { Pagination } from "antd";


const Recognitions = ({
  doSearch,
  doGetStats,
  recordList,
  pagination,
  recognitionStats
}) => {
  const [activeFilter, setActiveFilter] = useState("all");
  const [isShoutoutOpen, setIsShoutoutOpen] = useState(false);
  const [liveStats, setLiveStats] = useState(null);

  const handleToggleShoutout = () => {
    setIsShoutoutOpen((prev) => !prev);
  };
  const handleCloseShoutout = () => setIsShoutoutOpen(false);

  useEffect(() => {
    doSearch({ paginate: pagination.per_page });
    doGetStats();
  }, [doSearch, doGetStats, pagination.per_page]);

  useEffect(() => {
    if (recognitionStats) {
      setLiveStats(recognitionStats);
    }
  }, [recognitionStats]);

  const filteredRecords =
    activeFilter === "all"
      ? recordList
      : recordList?.filter(
          (item) =>
            item?.recognition_type?.toLowerCase() === activeFilter
        );

  const handleLocalLikeChange = (delta) => {
    setLiveStats(prev => {
      if (!prev) return prev;

      return {
        ...prev,
        total_likes: (prev.total_likes || 0) + delta,
      };
    });
  };
  return (
    <div className="space-y-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <SummaryCard
            dispalyCount={recognitionStats?.total_shoutouts || 0}
            description="Total Shoutouts"
            Icon={MessageCircleHeart}
            variant="purple"
          />

          <SummaryCard
            dispalyCount={recognitionStats?.weekly_shoutouts || 0}
            description="This Week"
            Icon={TrendingUp}
            variant="emerald"
          />

          <SummaryCard
            dispalyCount={liveStats?.total_likes || 0}
            description="Total Likes"
            Icon={Heart}
            variant="pink"
          />

          <SummaryCard
            dispalyCount={recognitionStats?.category_count || 0}
            description="Categories"
            Icon={Award}
            variant="amber"
          />
        </div>
        <FilterToolBar
          filters={recognitionFilters}
          activeFilter={activeFilter}
          onFilterChange={setActiveFilter}
          onActionClick={handleToggleShoutout}
        />
        {isShoutoutOpen && (
          <ShoutoutCard
            onClose={handleCloseShoutout}
            recordId="0"
          />
        )}
        <div className="space-y-4">
          {filteredRecords && filteredRecords.length > 0 ? (
            filteredRecords.map((shoutout) =>
              <RecognitionCard
                key={shoutout.rcw_id}
                recordData={shoutout}
                rcw_id={shoutout.rcw_id}
                onLikeChange={handleLocalLikeChange}
              />)
            ) : (
            <div className="text-center py-12">
              <Heart className="w-12 h-12 mx-auto mb-4 muted-text"/>
              <p className="text-slate-700">No recognition posts available</p>
            </div>
					)}
          {pagination?.total > pagination?.per_page && (
            <div className="flex justify-end py-4">
              <Pagination
                current={pagination?.current_page}
                pageSize={pagination?.per_page}
                total={pagination?.total}
                showSizeChanger={false}
                onChange={(page) =>
                  doSearch({
                    page,
                    paginate: pagination?.per_page,
                  })
                }
              />
            </div>
          )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.recognitionWall.recognitionWallList?.items,
  pagination: state.recognitionWall.recognitionWallList?.pagination,

  recognitionStats: state.overview.recognitionStats?.data,
  statsLoading: state.overview.recognitionStats?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getRecognitionWallList(filters)),
  doGetStats: () => dispatch(getRecognitionStats()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Recognitions);